export default "__VITE_ASSET__B0G5v2aI__"